// AUTO GENERATED FILE. DO NOT EDIT.
  import PageOrApp from 'tenants/_template/desktop/landing/[id]'

  

  
  export default PageOrApp;